// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__5wLKT","labelContent":"label_labelContent__Dn8bL"};